<template>
  <b-nav class="nav-toggled">
    <!-- <img class="Item" src="@/assets/PentagroIcon2.png" alt="Ícone Pentagro" /> -->

    <b-nav-item-dropdown id="dashboard" no-caret :text="$t('dashboard')" class="toggled" left>
      <b-dropdown-item class="drop-item" :to="`/dashboard/${user.Permissions.dashboard01.parameter}`"
        v-if="user.Permissions.dashboard01.permission && user.Permissions.dashboard01.allowed">
        <img id="dash-day" class="dropItem" src="@/assets/dashboard.png" :alt="$t('dashboard-01')" />
        {{ user.Permissions.dashboard01.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item" :to="`/dashboard/${user.Permissions.dashboard02.parameter}`"
        v-if="user.Permissions.dashboard02.permission && user.Permissions.dashboard02.allowed">
        <img id="dash-week" class="dropItem" src="@/assets/dashboard.png" :alt="$t('dashboard-02')" />
        {{ user.Permissions.dashboard02.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item" :to="`/dashboard/${user.Permissions.dashboard03.parameter}`"
        v-if="user.Permissions.dashboard03.permission && user.Permissions.dashboard03.allowed">
        <img id="dash-month" class="dropItem" src="@/assets/dashboard.png" :alt="$t('dashboard-03')" />
        {{ user.Permissions.dashboard03.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item" :to="`/dashboard/${user.Permissions.dashboard04.parameter}`"
        v-if="user.Permissions.dashboard04.permission && user.Permissions.dashboard04.allowed">
        <img id="dash-harvest" class="dropItem" src="@/assets/dashboard.png" :alt="$t('dashboard-04')" />
        {{ user.Permissions.dashboard04.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item" :to="`/dashboard/${user.Permissions.dashboard05.parameter}`"
        v-if="user.Permissions.dashboard05.permission && user.Permissions.dashboard05.allowed">
        <img id="dash-online" class="dropItem" src="@/assets/dashboard.png" :alt="$t('dashboard-05')" />
        {{ user.Permissions.dashboard05.permission }}
      </b-dropdown-item>

      <b-dropdown-item class="drop-item" id="indicatorconfig"
        v-if="user.Permissions.kpiconfiguration && user.Permissions.kpiconfiguration.permission && user.Permissions.kpiconfiguration.allowed && user.role == 'PGDI'"
        :to="`/kpiconfiguration`">
        <img id="kpi-configuration" class="dropItem" src="@/assets/dashboard2.png" :alt="user.Permissions.kpiconfiguration.permission" />{{
        user.Permissions.kpiconfiguration.permission }}
      </b-dropdown-item>

       <!-- <b-dropdown-item class="drop-item" id="editIndicator"
        v-if="user.Permissions.editordeindicadores && user.Permissions.editordeindicadores.permission && user.Permissions.editordeindicadores.allowed"
        :to="`/manageindicator`">
        <img id="editIndicator-img" class="dropItem" src="@/assets/atingirmeta.png" />
        {{ $t("manage-indicator") }}
      </b-dropdown-item>  -->
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DashboardDropdown",
  computed: mapState(["user"]),
};
</script>

<style scoped>
.txt {
  color: white;
  padding: 10px 20px;
}

img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.ilink {
  margin-right: 10px;
}
</style>

<style>
.dropdown-menu {
  height: auto;
  max-height: 350px;
  overflow-y: auto;
}
</style>
